import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from 'antd';
import { FiAlertTriangle } from 'react-icons/fi';
import {
  LinkOutlined,
} from '@ant-design/icons';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';
import CreatableSelect from 'react-select/creatable';
import DepartmentIcon from '@atlaskit/icon/core/department';

import {
  Button,
  Box,
  Flex,
  Portal,
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import httpInjectorService from 'services/http-injector.service';
import {
  FiEdit,
  FiMoreHorizontal,
} from 'react-icons/fi';
// import {settaskBoardDetails } from 'store/actions';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@chakra-ui/react';
import { MdOutlinePerson} from 'react-icons/md';
import { toast } from 'react-toastify';

import {
  useSortable,

} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
// import TaskModal from '../TaskManagement/TaskModal';
import UserAvatar from '../../../../components/userAvatar/index';
import LinkedItemsPopover from './LinkedItemPopover';

import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import TaskObject from '@atlaskit/object/task';


const getTaskDndId = (task) => {;
  if (task.id) return task.id;
  if (task.issue_id) return task.issue_id;
  throw new Error('Task must have either id or task_id');
};

const TaskCard = ({
  task,
  assigneeList,
  columnId,
  onOpenModal,
  openOptionModal,
  getTaskBoardDetails,
  Applyfilters,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: getTaskDndId(task),
    data: {
      type: 'task',
      columnId,
      statusName: task.status_name || task.issue_status,
    },
  });


  const [title, setTitle] = useState(task.title || task.issue_title);
  const [assigneeId, setAssigneeId] = useState(task.assignee_id || null);
  const [assigneeName, setAssigneeName] = useState(task.assignee_name || '');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [labelNote, setLabelNote] = useState('');
  const popoverRef = useRef(null);
  const [showPopover, setShowPopover] = useState(true);
  const [opendeleteModal, setdeletModal] = useState(false);
  const [labellist, setLabelList] = useState([]);
  const [issueTypeId, setIssueTypeId] = useState(
  task?.issue_type_id ?? task?.task?.issue_type_id
);
const [openIssueDropdown, setOpenIssueDropdown] =
  useState(false);
  const project_id = useParams();

  const menuButtonRef = useRef();
  const employeePopoverRef = useRef();
  const [showOptionMenu, setShowOptionMenu] = useState(false);
  const roleId = Number(Cookies.get('task-role-id'));

  const canDragTask = [1, 2, 3].includes(roleId);
  const dragProps = canDragTask ? { ...attributes, ...listeners } : {};

  const status = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const isboardfilterApplied = useSelector(
    (state) => state?.Authentication?.isboardfilterApplied,
  );

  const getfilteredrequestbody = useSelector(
    (state) => state?.Authentication?.filteredrequestbody,
  );

  const taskId= task.id || task.issue_id;

  useEffect(() => {
    setAssigneeName(task.assignee_name);
    setAssigneeId(task.assignee_id);
    setTitle(task.title || task.issue_title);
  }, [task]);

  // Sync selectedEmployee with assigneeId
  useEffect(() => {
    if (!assigneeList || !Array.isArray(assigneeList)) {
      setSelectedEmployee(null);
      return;
    }
    const found = assigneeList.find((emp) => emp.id === assigneeId) || null;
    setSelectedEmployee(found);
    if (found) setAssigneeName(found.name || found.username);
  }, [assigneeId, assigneeList]);

  const handleCardClick = (e) => {
    const isInsideUI =
      e.target.closest('button') ||
      e.target.closest('select') ||
      e.target.closest('input') ||
      e.target.closest('[role="dialog"]');
    if (!isInsideUI && onOpenModal) {
      onOpenModal(task);
    }
  };

  const handleOpenMenu = (e) => {
    e.stopPropagation(); // Prevent card click
    setShowOptionMenu(true);
  };

  const handleCloseMenu = () => {
    setShowOptionMenu(false);
  };

const handleUpdate = async (
  newTitle,
  newAssigneeId,
  newIssueTypeId
) => {

  const updatedTitle = newTitle ?? title;

  const updatedAssigneeId =
    newAssigneeId ?? assigneeId;

  // ADD THIS
  const updatedIssueTypeId =
    newIssueTypeId ?? issueTypeId;

  const hasTitleChanged =
    updatedTitle !== task.title;

  const hasAssigneeChanged =
    updatedAssigneeId !== task.assignee_id;

  const hasIssueTypeChanged =
    updatedIssueTypeId !== task.issue_type_id;

  if (
    !hasTitleChanged &&
    !hasAssigneeChanged &&
    !hasIssueTypeChanged
  ) {
    return;
  }

  try {
    await httpInjectorService.TaskUpdateTitleAssignee({
      project_id: project_id.id,
      issue_id: task.id || task.issue_id,

      // KEEP ONLY THIS ONE
      issue_type_id: updatedIssueTypeId,

      issue_title: updatedTitle,
      assignee_id: updatedAssigneeId,
      issue_status: task.task_status,

      work_item_url: `${window.location.origin}/admin/taskBoard/${project_id.id}/taskDetails/${task.id || task.issue_id}`,
    });

    getTaskBoardDetails();

    setTitle(updatedTitle);
    setAssigneeId(updatedAssigneeId);
    setIssueTypeId(updatedIssueTypeId);

  } catch (err) {
    console.error('Failed to update task:', err);
  }
};

  const handleStatusChange = async (selectedStatus) => {
    try {
      const reqBody = {
        project_id: task.project_id,
        issue_id: task.task.issue_id,
        issue_type_id:task.task.issue_type_id,
        issue_status: selectedStatus.status_name.toUpperCase(),
      };
      const response = await httpInjectorService.taskUpdateStatus(reqBody);
      if (response.status === 'success') {
        setShowOptionMenu(false);
          getTaskBoardDetails();
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error updating task:', error);
    } finally {
      setShowStatusOptions(false);
      // onClose();
    }
  };

  const menuItems = [
    {
      label: 'Change status',
      action: () => setShowStatusOptions((prev) => !prev),
      isExpandable: true,
    },

    { label: 'Add label', action: () => handleLabel() },

    ...([1, 2, 3].includes(roleId)
      ? [{ label: 'Delete', action: () => handledeletetask(), danger: true }]
      : []),
  ];

  const deleteTask = async () => {
    try {
      const response = await httpInjectorService.deleteTask({
        issue_id: task.task.issue_id,
        project_id: task.project_id,
        issue_type_id: task.task.issue_type_id,
      });
      if (response.status === 'success') {
        setdeletModal(false);
        getTaskBoardDetails();
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
    throw error
    }
  };

  const handleAddLabel = async () => {
    try {
      if (!selectedLabel || selectedLabel.length === 0) return;

      const newLabels = selectedLabel.filter((label) => label.__isNew__);
      const existingLabels = selectedLabel.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: task.project_id,
        issue_id: task.task.issue_id,
        issue_type_id:task.task.issue_type_id,
        sprint_id: task.task.sprint_id,
      };

      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      if (existingLabelIds.length > 0) {
        requestBody.labels_id = existingLabelIds;
      }

      const response = await httpInjectorService.createLabel(requestBody);

      if (response.status === 'success') {
        toast.success(response.message || 'Labels added to task successfully', {
          position: 'top-right',
          autoClose: 3000,
        });
        getTaskBoardDetails();
      } else {
        toast.error(response.message || 'Failed to add labels', {
          position: 'top-right',
          autoClose: 3000,
        });
      }

      setIsLabelModalOpen(false);
      setSelectedLabel([]);
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handledeletetask = () => {
    setShowPopover(false);
    setdeletModal(true);
  };

  const handleDeleteModalClose = () => {
    setdeletModal(false);
  };

  const handleLabelModalClose = () => {
    setIsLabelModalOpen(false);
    setSelectedLabel('');
    setLabelNote('');
  };

  const handleLabel = async () => {
    setShowOptionMenu(false);
    getLabelList();
    setIsLabelModalOpen(true);
    
    try {
      const response = await httpInjectorService.getLabelList(task.project_id);
      if (response.status === 'success') {
        setLabels(response.data);
      } else {
        toast.error('Failed to load labels');
      }
    } catch (error) {
     throw error;
    }
  };

  const getLabelList = async () => {
    try {
      let response = await httpInjectorService.getlabelList(task.project_id);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleAssigneeSelect = async (emp) => {
    setSelectedEmployee(emp);
    setAssigneeId(emp.user_id);
    setAssigneeName(emp.username);
    setShowEmployeePicker(false);
    await handleUpdate(undefined, emp.user_id);
  };

  const initials = assigneeName
    ? assigneeName
        .split(' ')
        .map((part) => part[0])
        .join('')
        .toUpperCase()
    : null;

  const subtaskTotal = task.subtasks_count?.total ?? 0;
  const subtaskDone = task.subtasks_count?.done ?? 0;

  const ISSUE_TYPES = [
  { id: 1, label: 'Task', Icon: TaskObject },
  { id: 2, label: 'Story', Icon: StoryObject },
  { id: 3, label: 'Bug', Icon: BugObject },
];

  const ISSUE_TYPE_ICON_MAP = {
    1: TaskObject, // TASK
    2: StoryObject, // STORY
    3: BugObject, // BUG
  };

  const IssueIcon =
  ISSUE_TYPE_ICON_MAP[issueTypeId];

 

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      {...dragProps}
      data-tour="task-card"
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        marginBottom: 1,
        marginTop: 2,
        cursor: 'grab',
        width: '100%',
      }}
      onClick={handleCardClick}
    >
      <div
        style={{
          width: '100%',
          minHeight: 130,
          padding: 15,
          background: '#fff',
          position: 'relative',
          border: '1px solid #eee',
          borderRadius: 6,
          boxShadow: '0 0 16px rgba(0, 0, 0, 0.1)',
          boxSizing: 'border-box',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {/* Title Row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 16,
          }}
        >
          {isEditingTitle ? (
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onBlur={() => {
                setIsEditingTitle(false);
                handleUpdate(title, undefined);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setIsEditingTitle(false);
                  handleUpdate(title, undefined);
                }
              }}
              autoFocus
              onClick={(e) => e.stopPropagation()}
              style={{
                fontSize: 16,
                width: '100%',
                padding: '4px 8px',
              }}
            />
          ) : (
            <>
              <div
                style={{
                  fontSize: 16,
                  flexGrow: 1,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 'calc(100% - 64px)',
                }}
                title={title}
              >
                {title}
              </div>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setIsEditingTitle(true);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#666',
                }}
              >
                <FiEdit size={16} />
              </button>
              <Popover
                isOpen={showOptionMenu}
                onClose={() => setShowOptionMenu(false)}
                placement="left-start"
              >
                <PopoverTrigger>
                  <span
                    ref={menuButtonRef}
                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowOptionMenu(true);
                    }}
                  >
                    <FiMoreHorizontal size={18} />
                  </span>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent
                    zIndex={9999}
                    width="240px"
                    borderRadius="8px"
                    boxShadow="md"
                    padding="0"
                  >
                    <PopoverBody p="4px 0">
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {menuItems.map((item) => (
                          <div
                            key={item.label}
                            style={{ position: 'relative' }}
                          >
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                item.action();
                              }}
                              style={{
                                padding: '8px 16px',
                                background: 'none',
                                border: 'none',
                                textAlign: 'left',
                                cursor: 'pointer',
                                color: item.danger ? 'red' : '#333',
                                fontSize: '14px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                              }}
                            >
                              <span>{item.label}</span>

                              <span style={{ fontSize: '12px', color: '#888' }}>
                                {item.isExpandable ? '▶' : '›'}
                              </span>
                            </button>

                            {item.label === 'Change status' &&
                              showStatusOptions && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: '100%',
                                    marginLeft: '4px',
                                    background: '#fff',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    zIndex: 99999,
                                    padding: '4px 0',
                                    width: '180px',
                                  }}
                                >
                                  {status.map((s) => (
                                    <button
                                      key={s.id}
                                      onClick={() => handleStatusChange(s)}
                                      style={{
                                        padding: '6px 12px',
                                        background: 'none',
                                        border: 'none',
                                        textAlign: 'left',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        width: '100%',
                                      }}
                                    >
                                      {s.status_name}
                                    </button>
                                  ))}
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>
            </>
          )}
        </div>
        {/* epiclabel */}
        {/* Bottom Labels */}
        <div
          style={{
            position: 'absolute',
            bottom: 12, // distance from bottom (adjust as needed)
            left: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          {/* Epic Name */}
          {(task?.task?.epic_name ?? task?.epic_name) && (
            <div
              style={{
                fontSize: 11,
                color: '#5B21B6',
                fontWeight: 500,
                backgroundColor: '#E9D8FD',
                padding: '1px 8px',
                borderRadius: 4,
                maxWidth: '95%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={task?.task?.epic_name ?? task?.epic_name}
            >
              {task?.task?.epic_name ?? task?.epic_name}
            </div>
          )}

          {/* Due Date (only if past due) */}
          {(task?.task?.end_date ?? task?.due_date) &&
            new Date(task?.task?.end_date ?? task?.due_date) < new Date() && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  border: '1px solid #DC2626',
                  color: '#DC2626',
                  fontSize: 11,
                  fontWeight: 500,
                  padding: '1px 8px',
                  borderRadius: 4,
                  backgroundColor: '#FFF5F5',
                  maxWidth: 'fit-content',
                }}
                title={`Due: ${new Date(
                  task?.task?.end_date ?? task?.due_date,
                ).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}`}
              >
                <FiAlertTriangle size={14} />
                {new Date(
                  task?.task?.end_date ?? task?.due_date,
                ).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </div>
            )}

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              marginTop: 2,
              maxWidth: 'fit-content',
            }}
          >
       <Popover
  isOpen={openIssueDropdown}
  onClose={() => setOpenIssueDropdown(false)}
  placement="top-start"
>
  <PopoverTrigger>
    <div
      onClick={(e) => {
        e.stopPropagation();
        setOpenIssueDropdown((prev) => !prev);
      }}
      style={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {IssueIcon ? (
        <IssueIcon width={16} />
      ) : (
        <span
          style={{
            fontSize: 10,
            color: '#999',
          }}
        >
          —
        </span>
      )}
    </div>
  </PopoverTrigger>

  <Portal>
    <PopoverContent
      width="140px"
      zIndex={99999}
    >
      <PopoverBody p="4px">
        {ISSUE_TYPES.map(
          ({ id, label, Icon }) => (
            <div
              key={id}
              onClick={(e) => {
                e.stopPropagation();

                setOpenIssueDropdown(false);

                setIssueTypeId(id);

                handleUpdate(
                  undefined,
                  undefined,
                  id
                );
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px',
                cursor: 'pointer',
                borderRadius: 4,
              }}
            >
              <Icon width={16} />
              <span>{label}</span>
            </div>
          )
        )}
      </PopoverBody>
    </PopoverContent>
  </Portal>
</Popover>
            {/* Task Key */}
            <div
              style={{
                fontSize: 11,
                color: '#666',
                fontWeight: 500,
                backgroundColor: '#f1f1f1',
                padding: '1px 8px',
                borderRadius: 4,
                maxWidth: 'fit-content',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={task?.task?.issue_key}
            >
              {task?.task?.issue_key || task?.issue_key}
            </div>
          </div>
        </div>

        {/* Assignee Popover */}
        <div
          style={{
            position: 'absolute',
            bottom: 16,
            right: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
      <LinkedItemsPopover item_id={taskId} item_type={"issue"}  details={task}/>
          {subtaskTotal > 0 && (
            <Tooltip
              title={`${subtaskDone} of ${subtaskTotal} child work items complete`}
              placement="top"
              hasArrow
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'default',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <DepartmentIcon label="Department" size="small" />
              </span>
            </Tooltip>
          )}

          <Popover
            isOpen={showEmployeePicker}
            onClose={() => setShowEmployeePicker(false)}
            placement="top-end"
          >
            <PopoverTrigger>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEmployeePicker(!showEmployeePicker);
                }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                title={assigneeName || 'Unassigned'}
              >
                {assigneeName ? (
                  <UserAvatar username={assigneeName} size={24} />
                ) : (
                  <MdOutlinePerson size={20} color="#999" />
                )}
              </span>
            </PopoverTrigger>
            <Portal>
              <PopoverContent
                ref={employeePopoverRef}
                width="auto"
                zIndex={9999}
              >
                <PopoverBody>
                  {assigneeList?.length > 0 ? (
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {assigneeList.map((emp) => (
                        <Flex
                          key={emp.user_id}
                          align="center"
                          p="6px 10px"
                          borderRadius="6px"
                          cursor="pointer"
                          bg={
                            selectedEmployee?.user_id === emp.user_id
                              ? '#e6f4ff'
                              : 'transparent'
                          }
                          _hover={{ background: '#f0f0f0' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAssigneeSelect(emp);
                          }}
                        >
                          <Box w="24px" h="24px" mr="8px">
                            <UserAvatar username={emp.username} size={24} />
                          </Box>
                          <Box fontSize="14px" color="#333">
                            {emp.username}
                          </Box>
                        </Flex>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: '#888' }}>
                      No employees found
                    </div>
                  )}
                </PopoverBody>
              </PopoverContent>
            </Portal>
          </Popover>
        </div>
      </div>
      <Modal isOpen={isLabelModalOpen} onClose={handleLabelModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Label to {task.epic_key}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Select
                    placeholder="Select label"
                    value={selectedLabel}
                    onChange={(e) => setSelectedLabel(e.target.value)}
                    mb={4}
                  >
                    {labellist.map((label) => (
                      <option key={label.label_id} value={label.label_id}>
                        {label.label_name}
                      </option>
                    ))}
                  </Select> */}
            {/* <Select
        placeholder="Select label"
        value={JSON.stringify(selectedLabel)}
        onChange={(e) => setSelectedLabel(JSON.parse(e.target.value))}
        mb={4}
      >
        {labellist.map((label) => (
          <option key={label.label_id} value={JSON.stringify(label)}>
            {label.label_name}
          </option>
        ))}
      </Select> */}
            <CreatableSelect
              placeholder="Select or create label"
              isClearable
              isMulti
              value={selectedLabel}
              options={labellist.map((label) => ({
                label: label.label_name,
                value: label.label_id,
                __isNew__: false,
              }))}
              onChange={(newValue) => {
                if (!newValue) {
                  setSelectedLabel([]);
                  return;
                }

                const uniqueLabels = [];
                const seen = new Set();

                newValue.forEach((label) => {
                  const normalized = label.label.toLowerCase();

                  if (!seen.has(normalized)) {
                    seen.add(normalized);

                    // ✅ if label already exists in labellist (case-insensitive), reuse it
                    const existing = labellist.find(
                      (opt) => opt.label_name.toLowerCase() === normalized,
                    );

                    if (existing) {
                      uniqueLabels.push({
                        label: existing.label_name,
                        value: existing.label_id,
                        __isNew__: false,
                      });
                    } else {
                      uniqueLabels.push(label); // keep newly created label
                    }
                  }
                });

                setSelectedLabel(uniqueLabels);
              }}
              formatCreateLabel={(inputValue) =>
                `Create new label: "${inputValue}"`
              }
              isValidNewOption={(inputValue, _, options) =>
                inputValue.trim() !== '' &&
                !options.some(
                  (option) =>
                    option.label.toLowerCase() === inputValue.toLowerCase(),
                )
              }
            />

            {/* <Input
                    placeholder="Add a note (optional)"
                    value={labelNote}
                    onChange={(e) => setLabelNote(e.target.value)}
                  /> */}
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
              mr={3}
              onClick={handleAddLabel}
            >
              Done
            </Button>
            <Button variant="ghost" onClick={handleLabelModalClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={opendeleteModal} onClose={handleDeleteModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to delete the task?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>This action cannot be undone.</Text>
            <Text>Please confirm if you really want to proceed.</Text>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
              mr={3}
              onClick={deleteTask}
            >
              Confirm
            </Button>
            <Button variant="ghost" onClick={handleDeleteModalClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default TaskCard;
